import React from 'react'
import { Link } from 'react-router-dom'

export default (props) =>  {

  let order = { order: props.menu_order }

  const title_parsed = props.title.toLowerCase().replace(/ /g,'-');
  return (
    <div data-c="IssueItem" style={{...order}}>
      <Link 
        to={title_parsed}
      >
        {props.title} - {props.object}
      </Link>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/navigation/NavItem.js